import * as React from "react";

export class Body extends React.Component<{}, {}> {
    render() {
        return (
            <tbody>
                {this.props.children}
            </tbody>
        );
    }
}